import { ProgressBar } from '@sgme/ui';
import { FC } from 'react';
import type { TimeInterval } from 'state/quotes/dashboard/model';

import type { ResultColor } from './model';
import { useAutoRefreshTimer } from './useAutoRefreshTimer';

export const AutoRefreshProgress: FC<{
  timer: TimeInterval;
  color: ResultColor;
  isCountDown: boolean;
}> = ({ timer, color, isCountDown }) => {
  const { progressInPercent } = useAutoRefreshTimer(timer);
  const progress = isCountDown ? 100 - progressInPercent : progressInPercent;
  return <ProgressBar size="sm" color={color} value={progress} />;
};

AutoRefreshProgress.displayName = 'AutoRefreshProgress';
